import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPersonSlash12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconPersonSlash12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.416 2.869C8.169 1.799 7.18 1 6 1 4.633 1 3.525 2.07 3.525 3.391c0 .775.381 1.464.973 1.9A4 4 0 0 0 2 9v.284l1.117-1.117a3 3 0 0 1 2.05-2.05l1.47-1.47A1.5 1.5 0 0 1 6 4.784c-.847 0-1.475-.655-1.475-1.392S5.153 2 6 2s1.475.655 1.475 1.391c0 .185-.04.365-.112.53zM7.499 6.4 3.9 10H9V9c0-1.11-.603-2.08-1.5-2.6M2.9 11l-.846.847a.5.5 0 0 1-.707-.708l8.838-8.838a.5.5 0 0 1 .708.707L8.225 5.675A4 4 0 0 1 10 9v2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPersonSlash12);
